(function () {
  let clearActivityButtons = document.querySelectorAll(".js-clear-activity");
  if (clearActivityButtons) {
    clearActivityButtons.forEach(function (button) {
      button.addEventListener("click", function (event) {
        const modalId = event.target.dataset.target;
        const modal = document.getElementById(modalId);
        const modalOverlay = document.getElementById("modalOverlay");
        const formItem = event.target.closest(".evaluation-form-item");

        if (modal && formItem) {
          // Show modal and overlay
          modal.removeAttribute("aria-hidden");
          modal.classList.add("open");
          modalOverlay.style.display = "block";

          // Handle confirm button
          const confirmButton = modal.querySelector(".js-clear-confirmation");
          if (confirmButton) {
            confirmButton.addEventListener(
              "click",
              function () {
                // Clear all non-hidden inputs and textareas
                const visibleInputs = formItem.querySelectorAll(
                  'input:not([type="hidden"]), textarea'
                );
                visibleInputs.forEach((input) => {
                  if (input.type === "checkbox") {
                    input.checked = false;
                  } else {
                    input.value = "";
                  }
                });

                // Find and remove custom measures (both process and impact)
                const allMeasures = formItem.querySelectorAll(".simple-card");
                allMeasures.forEach((measureCard) => {
                  const isPreConfiguredInput = measureCard.querySelector(
                    'input[name*="is_pre_configured"]'
                  );
                  if (
                    isPreConfiguredInput &&
                    isPreConfiguredInput.value.toLowerCase() === "false"
                  ) {
                    // Get the parent evaluation form before removing the card
                    const parentForm = measureCard.closest(
                      ".js-evaluation-form"
                    );
                    measureCard.remove();

                    // Update TOTAL_FORMS counter
                    if (parentForm) {
                      const totalFormsInput = parentForm.querySelector(
                        'input[name*="TOTAL_FORMS"]'
                      );
                      if (totalFormsInput) {
                        let currentTotal = parseInt(totalFormsInput.value);
                        totalFormsInput.value = Math.max(0, currentTotal - 1);
                      }
                    }
                  } else {
                    // If not custom, just uncheck the checkbox
                    const checkbox = measureCard.querySelector(
                      'input[type="checkbox"]'
                    );
                    if (checkbox) {
                      checkbox.checked = false;
                      // Remove is-selected class from parent card
                      measureCard.classList.remove("is-selected");
                    }
                  }
                });

                // Clear custom title
                const customTitle = formItem.querySelector(".custom_title");
                if (customTitle) {
                  customTitle.textContent = "";
                }

                // Remove selected state
                formItem.classList.remove("is-selected");

                // Close expanded sections
                const expandedButtons = formItem.querySelectorAll(
                  '[aria-expanded="true"]'
                );
                expandedButtons.forEach((button) => button.click());

                // Hide modal and overlay
                modal.setAttribute("aria-hidden", "true");
                modal.classList.remove("open");
                modalOverlay.style.display = "none";
              },
              { once: true }
            );
          }
        }
      });
    });
  }
})();
